<template>
  <!--后退-->
  <div v-if="!['/aqt','/External'].includes($route.path)" class="goback"><i @click="goBack" class="iconfont iconai207"></i></div>
</template>

<script>
export default {
  props:{
    url:String
  },
  data(){
    return{

    }
  },
  methods:{
    goBack(){
      let that = this
      if(that.url){
        that.$router.push({
          path:that.url,
          query:{
            lib_type:sessionStorage.getItem('gcm')
          }
        })
      }else {
        that.$router.go(-1)
      }

    }
  }
}
</script>
<style lang="less" scoped>
.goback {
  width: 35px;
  height: 35px;
  position: absolute;
  right: 0px;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
  border: 1px solid var(--themeColor);
  border-radius: 50%;
  i{
    color: var(--themeColor);
    font-size: 26px;
  }
}
.goback:hover{
  background-color: var(--themeColor);
  i{
    color: #FFB600;
  }
}
</style>
